/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import isInExternalEnvironment from 'actions/app/isInExternalEnvironment';

export const MapStateToProps = (state = {}, props) => ({
  inExternalTestEnvironment: isInExternalEnvironment(state)
});

